import React from "react";
import { Link } from "react-router-dom";
import { Mail, Phone } from "lucide-react";
import { Logo } from "./Logo";

export const Footer = () => {
  return (
    <footer data-testid="main-footer" className="bg-charcoal text-white">
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-16">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12">
          <div>
            <Logo dark />
            <p className="mt-6 text-white/60 text-sm leading-relaxed max-w-xs font-body">
              A local web design agency helping small businesses build a professional online presence.
            </p>
          </div>

          <div>
            <h4 className="font-display text-sm uppercase tracking-widest text-sky-brand mb-5">Explore</h4>
            <ul className="space-y-3 font-body text-white/70">
              <li><Link to="/" className="hover:text-sky-brand transition-colors">Home</Link></li>
              <li><Link to="/services" className="hover:text-sky-brand transition-colors">Services</Link></li>
              <li><Link to="/about" className="hover:text-sky-brand transition-colors">About</Link></li>
              <li><Link to="/contact" className="hover:text-sky-brand transition-colors">Contact</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="font-display text-sm uppercase tracking-widest text-sky-brand mb-5">Get in touch</h4>
            <ul className="space-y-4 font-body text-white/70 text-sm">
              <li className="flex items-center gap-3"><Mail size={16} className="text-sky-brand" /> <a href="mailto:elevatedweb.tx@gmail.com" data-testid="footer-email-link" className="hover:text-sky-brand transition-colors">elevatedweb.tx@gmail.com</a></li>
              <li className="flex items-center gap-3"><Phone size={16} className="text-sky-brand" /> <a href="sms:8329102910" data-testid="footer-phone-link" className="hover:text-sky-brand transition-colors">832-910-2910</a></li>
            </ul>
          </div>
        </div>

        <div className="mt-16 pt-8 border-t border-white/10 flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="text-white/40 text-xs font-body">© {new Date().getFullYear()} Elevated Web. All rights reserved.</p>
          <Link
            to="/contact"
            className="font-display text-xs font-semibold tracking-wide text-sky-brand hover:text-white transition-colors"
          >
            Get Your Free Website Preview →
          </Link>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
